// Hand-laid architecture diagrams for the Docs page, rendered by
// components/DocsDiagram.js. Coordinates are grid units (x ~200px, y ~92px).
// Tints: app (blue) · cloud (purple) · aws (orange) · house (green) · dev (plain).

export const bigPicture = {
  height: 560,
  nodes: [
    { id: 'you', x: 1.5, y: 0, label: 'You — browser / phone', sub: 'amalfi.house · home-screen app', tint: 'app', kind: 'client' },
    { id: 'spa', x: 0.5, y: 1, label: 'React app', sub: 'Firebase Hosting (amalfi.house)', tint: 'app' },
    { id: 'api', x: 2.5, y: 1, label: 'api.amalfi.house', sub: 'CloudFront → backend', tint: 'aws' },
    { id: 'fs', x: 0.5, y: 2.3, label: 'Firestore', sub: 'database · job queue · command bus', tint: 'cloud', kind: 'core' },
    { id: 'auth', x: -0.75, y: 2.3, label: 'Firebase Auth', sub: 'sign-in + allowlists', tint: 'cloud' },
    { id: 'be', x: 2.5, y: 2.3, label: 'Backend — ECS Fargate', sub: 'upload API · voice agent · workers · fan-out', tint: 'aws' },
    { id: 's3', x: 3.75, y: 3.4, label: 'S3 + CDN', sub: 'raw uploads · public media', tint: 'aws' },
    { id: 'bridge', x: 1.25, y: 3.6, label: 'Bridge service (AWS)', sub: 'ISY Insteon · iAquaLink pool/spa', tint: 'aws' },
    { id: 'pi', x: 2.55, y: 3.6, label: 'Housebox Pi (at the house)', sub: 'Home Assistant · bridges · local voice', tint: 'house' },
    { id: 'insteon', x: 0.6, y: 4.8, label: 'Insteon switches & scenes', sub: 'via ISY-994i', tint: 'dev' },
    { id: 'pool', x: 1.75, y: 4.8, label: 'Pool & spa', sub: 'Zodiac cloud', tint: 'dev' },
    { id: 'devs', x: 2.9, y: 4.8, label: 'Lamps · AC · shades · cameras', sub: 'BLE proxies · Rollease hub · Ring', tint: 'dev' },
    { id: 'stick', x: 4.05, y: 4.8, label: 'Voice remote', sub: 'M5StickS3 satellite', tint: 'dev' },
  ],
  edges: [
    { from: 'you', to: 'spa' },
    { from: 'you', to: 'api', label: 'uploads · voice' },
    { from: 'spa', to: 'fs', label: 'realtime (onSnapshot)', animated: true },
    { from: 'spa', to: 'auth', dashed: true },
    { from: 'api', to: 'be' },
    { from: 'be', to: 'fs', label: 'firebase-admin' },
    { from: 'be', to: 's3' },
    { from: 'fs', to: 'bridge', label: 'commands ↓ state ↑', animated: true },
    { from: 'fs', to: 'pi', label: 'commands ↓ state ↑', animated: true },
    { from: 'bridge', to: 'insteon' },
    { from: 'bridge', to: 'pool' },
    { from: 'pi', to: 'devs' },
    { from: 'pi', to: 'stick' },
  ],
};

export const commandBus = {
  height: 540,
  nodes: [
    { id: 'ui', x: 0.4, y: 0, label: 'Controls page', sub: 'buttons · sliders · scenes', tint: 'app' },
    { id: 'voice', x: 1.6, y: 0, label: 'Voice assistant', sub: 'in-app or house remote', tint: 'app' },
    { id: 'auto', x: 2.8, y: 0, label: 'Automations', sub: 'dimmer heal · auto-off · temp sampler', tint: 'aws' },
    { id: 'cmd', x: 1.6, y: 1.2, label: 'controlCommands', sub: 'Firestore doc, status: pending', tint: 'cloud', kind: 'queue' },
    { id: 'isy', x: 0, y: 2.5, label: 'ISY bridge', sub: 'AWS · Insteon via DDNS', tint: 'aws' },
    { id: 'aqua', x: 1.1, y: 2.5, label: 'Aqualink bridge', sub: 'AWS · Zodiac cloud', tint: 'aws' },
    { id: 'ha', x: 2.2, y: 2.5, label: 'HA bridge', sub: 'Pi · target: ha', tint: 'house' },
    { id: 'shade', x: 3.3, y: 2.5, label: 'Shade bridge', sub: 'Pi · target: shade', tint: 'house' },
    { id: 'd1', x: 0, y: 3.7, label: 'Switches · dimmers · scenes', tint: 'dev' },
    { id: 'd2', x: 1.1, y: 3.7, label: 'Pumps · heaters · lights', tint: 'dev' },
    { id: 'd3', x: 2.2, y: 3.7, label: 'Dyson lamps · Gree AC', tint: 'dev' },
    { id: 'd4', x: 3.3, y: 3.7, label: 'Motorized shades', tint: 'dev' },
    { id: 'mirror', x: 1.6, y: 4.9, label: 'controlDevices mirror', sub: 'each bridge publishes live state back', tint: 'cloud' },
  ],
  edges: [
    { from: 'ui', to: 'cmd' },
    { from: 'voice', to: 'cmd' },
    { from: 'auto', to: 'cmd', dashed: true },
    { from: 'cmd', to: 'isy', animated: true },
    { from: 'cmd', to: 'aqua', animated: true },
    { from: 'cmd', to: 'ha', animated: true },
    { from: 'cmd', to: 'shade', animated: true },
    { from: 'isy', to: 'd1' },
    { from: 'aqua', to: 'd2' },
    { from: 'ha', to: 'd3' },
    { from: 'shade', to: 'd4' },
    { from: 'd1', to: 'mirror', dashed: true },
    { from: 'd2', to: 'mirror', dashed: true },
    { from: 'd3', to: 'mirror', dashed: true },
    { from: 'd4', to: 'mirror', dashed: true },
  ],
};

export const uploads = {
  height: 500,
  nodes: [
    { id: 'owner', x: 0.3, y: 0, label: 'Owner in the app', sub: 'any space or room', tint: 'app' },
    { id: 'guest', x: 2.3, y: 0, label: 'Guest with a drop link', sub: '/u/⟨token⟩ · optional passcode · no account', tint: 'app' },
    { id: 'api', x: 1.3, y: 1.2, label: 'Upload API', sub: 'create → sign → complete (presigned multipart)', tint: 'aws' },
    { id: 's3', x: 1.3, y: 2.4, label: 'S3 raw bucket', sub: 'parts upload in parallel, resumable across reloads', tint: 'aws', kind: 'direct' },
    { id: 'asset', x: 1.3, y: 3.6, label: 'Asset doc in Firestore', sub: 'provenance + meta.status: queued', tint: 'cloud' },
    { id: 'meta', x: 0.3, y: 4.8, label: 'Meta worker', sub: 'claims, verifies, extracts metadata', tint: 'aws' },
    { id: 'cdn', x: 2.3, y: 4.8, label: 'CDN playback', sub: 'presigned or public URLs', tint: 'aws' },
    { id: 'watch', x: 3.3, y: 1.2, label: 'Live progress', sub: 'upload heartbeats mirror to Firestore — owner watches', tint: 'cloud' },
  ],
  edges: [
    { from: 'owner', to: 'api' },
    { from: 'guest', to: 'api', label: 'token-gated' },
    { from: 'api', to: 's3', label: 'browser → S3 direct', animated: true },
    { from: 'guest', to: 'watch', dashed: true },
    { from: 's3', to: 'asset' },
    { from: 'asset', to: 'meta', animated: true },
    { from: 'meta', to: 'cdn' },
  ],
};

export const fanout = {
  height: 500,
  nodes: [
    { id: 'job', x: 1.3, y: 0, label: 'jobs/⟨id⟩ doc', sub: "kind: 'fanout' · status: queued", tint: 'cloud', kind: 'queue' },
    { id: 'orch', x: 1.3, y: 1.2, label: 'Orchestrator', sub: 'always-on service adopts the job', tint: 'aws' },
    { id: 'prep', x: 0, y: 2.4, label: 'Prep task', sub: 'plans the units of work', tint: 'aws' },
    { id: 'chunks', x: 1.3, y: 2.4, label: 'Chunk tasks × N', sub: 'parallel Fargate waves, concurrency capped', tint: 'aws', kind: 'fan-out' },
    { id: 'stitch', x: 2.6, y: 2.4, label: 'Stitch task', sub: 'merges partials', tint: 'aws' },
    { id: 'scratch', x: 0.65, y: 3.6, label: 'S3 scratch', sub: '_scratch/jobs/⟨id⟩/', tint: 'aws' },
    { id: 'result', x: 2.6, y: 3.6, label: 'Result', sub: 'public bucket / Firestore', tint: 'aws' },
    { id: 'kill', x: 3.5, y: 0, label: 'jobControls/⟨id⟩', sub: 'cancel · pause · resume', tint: 'cloud' },
    { id: 'tasks', x: 0, y: 1.2, label: 'Per-task telemetry', sub: 'jobs/⟨id⟩/tasks → Processes page', tint: 'cloud' },
  ],
  edges: [
    { from: 'job', to: 'orch', animated: true },
    { from: 'orch', to: 'prep' },
    { from: 'prep', to: 'chunks' },
    { from: 'chunks', to: 'stitch' },
    { from: 'chunks', to: 'scratch', dashed: true },
    { from: 'stitch', to: 'result' },
    { from: 'kill', to: 'orch', dashed: true, label: 'watched live' },
    { from: 'orch', to: 'tasks', dashed: true },
  ],
};

export const voicePaths = {
  height: 560,
  nodes: [
    { id: 'mic', x: 0, y: 0, label: 'App voice (mic)', sub: 'realtime session, speaks + listens', tint: 'app' },
    { id: 'chatui', x: 1.2, y: 0, label: 'App text chat', sub: 'assistant panel', tint: 'app' },
    { id: 'stick', x: 2.9, y: 0, label: 'House remote (PTT)', sub: 'M5StickS3 — tap, speak, release', tint: 'dev' },
    { id: 'rt', x: 0, y: 1.2, label: 'Realtime voice model', sub: 'ephemeral token · audio in/out', tint: 'cloud' },
    { id: 'whisper', x: 2.9, y: 1.2, label: 'Whisper STT — on the Pi', sub: 'audio never leaves the LAN', tint: 'house' },
    { id: 'agent', x: 2.9, y: 2.4, label: 'amalfi_voice HA agent', sub: 'owner token · fastAck', tint: 'house' },
    { id: 'chat', x: 1.45, y: 3.5, label: '/voice/chat + tool registry', sub: 'one brain: controls · scenes · knowledge · media', tint: 'aws', kind: 'brain' },
    { id: 'bus', x: 0.4, y: 4.7, label: 'Command bus', sub: 'controlCommands → bridges → devices', tint: 'cloud' },
    { id: 'rag', x: 1.6, y: 4.7, label: 'House knowledge', sub: 'embedded chunks, vector search', tint: 'cloud' },
    { id: 'piper', x: 2.9, y: 4.7, label: 'Piper TTS → speaker', sub: 'reply spoken on the remote', tint: 'house' },
  ],
  edges: [
    { from: 'mic', to: 'rt', animated: true },
    { from: 'rt', to: 'chat', label: 'tool calls' },
    { from: 'chatui', to: 'chat' },
    { from: 'stick', to: 'whisper', animated: true },
    { from: 'whisper', to: 'agent', label: 'transcript' },
    { from: 'agent', to: 'chat' },
    { from: 'chat', to: 'bus', animated: true },
    { from: 'chat', to: 'rag', dashed: true },
    { from: 'chat', to: 'piper', label: 'reply' },
  ],
};

export const remoteAccess = {
  height: 420,
  nodes: [
    { id: 'phone', x: 0, y: 0.9, label: 'Your phone / laptop', sub: 'anywhere in the world', tint: 'app' },
    { id: 'ts', x: 1.2, y: 0.9, label: 'Tailscale tailnet', sub: 'WireGuard — device identity, not passwords', tint: 'cloud', kind: 'zero-trust' },
    { id: 'pi', x: 2.4, y: 0.9, label: 'Housebox Pi', sub: 'subnet router for the LAN', tint: 'house' },
    { id: 'router', x: 3.6, y: 0, label: 'Router admin UI', sub: 'LAN-only, reached via tailnet', tint: 'dev' },
    { id: 'ha', x: 3.6, y: 0.9, label: 'Home Assistant', sub: ':8123 on the Pi', tint: 'dev' },
    { id: 'cams', x: 3.6, y: 1.8, label: 'Live cameras', sub: 'go2rtc web player', tint: 'dev' },
    { id: 'pub', x: 1.2, y: 2.4, label: 'Public internet path', sub: 'amalfi.house + api only — no router ports open for admin', tint: 'aws' },
  ],
  dir: 'h',
  edges: [
    { from: 'phone', to: 'ts', animated: true },
    { from: 'ts', to: 'pi' },
    { from: 'pi', to: 'router' },
    { from: 'pi', to: 'ha' },
    { from: 'pi', to: 'cams' },
    { from: 'phone', to: 'pub', dashed: true, label: 'the app itself' },
  ],
};
